<template>
  <div class="d-flex flex-wrap p-2">
    <div class="alert alert-danger w-100 d-flex flex-wrap align-center"
         v-if="endLicense"
         role="alert">
      <i class="fa-light fa-triangle-exclamation"></i>
      لایسنس استاندارد مدیریت مخاطبین منقضی شد، برای جلوگیری از حذف سرویس تا ۲۴ ساعت آینده صورتحساب مربوطه را پرداخت
      نمایید.
      <router-link active-class="btn-pay" to="" class="mr-auto">پرداخت صورتحساب</router-link>
    </div>
    <div class="center-sec">
      <div v-if="product_type !== 'hosted'" class="box-main">
        <div class="head pb-4">
          <i class="icon-1"></i>
          <div v-if="licenseActive" class="txt">
            <h6>{{ currentLicense.plan_name }}</h6>
            <span>پلن فعال: استاندارد</span>
          </div>
          <div v-else class="mr-2">
            شما هیچ پلن فعالی ندارید
          </div>
        </div>

        <template v-if="licenseActive">
          <div class="d-flex flex-wrap">
            <div v-if="product_type !== 'hosted'" class="box-mini">
              <div class="error mb-2" v-if="endLicense">
                <span> سرویس شما {{ currentLicense.count_day_to_expire }} روز دیگر به پایان می رسد!</span>
                <a class="btn">پرداخت صورتحساب</a>

              </div>
              <span v-else>{{ currentLicense.remaining_days }} روز از {{ currentLicense.total_days }} روز </span>
              <div class="progress-line">
                <i :class="{'bg-error2':endLicense}"
                   :style="'width:'+calculatePercentage(currentLicense?.remaining_days,currentLicense?.total_days)+'%'"></i>
              </div>
            </div>
            <div class="box-mini">
              <span>{{ usersC }} کاربر  از  {{ currentLicense.user_count }} کاربر</span>
              <div class="progress-line">
                <i :class="{'bg-error2':endLicense}"
                   :style="'width:'+calculatePercentage(usersC,currentLicense.user_count)+'%'"></i>
              </div>
            </div>
            <div class="box-mini">
              <span>توکن باقی مانده هوش مصنوعی : {{ aiTokenBalance.toLocaleString() }}</span>

            </div>
          </div>

          <div v-if="pendingBill !== '' && pendingBill !== null" class="factor-pay">
            <div class="head">
              <h5><i class="fa-regular fa-triangle-exclamation"></i> فاکتور افزایش تعداد کاربران</h5>
              <button>در انتظار پرداخت</button>
            </div>
            <ul>
              <li>
                <h6><i class="fa-regular fa-user"></i>تعداد کاربر جدید:</h6>
                <span>{{ pendingBill?.pending_user_count }}</span>
              </li>
              <li>
                <h6><i class="fa-regular fa-user"></i>مبلغ قابل پرداخت:</h6>
                <span>{{ pendingBill?.amount?.toLocaleString() }} تومان</span>
              </li>
            </ul>
            <div class="btns-2">
              <v-btn :loading="loadingCancel" class="btn btn-cancel" @click="billsCancel">لغو و انصراف</v-btn>
              <button @click="getPayUrl" class="btn btn-pay">پرداخت صورتحساب
                <span class="mr-2" v-if="!isExpired"> {{ formattedTime }}</span>
              </button>

            </div>

          </div>

          <div v-if="reservedLicense !== null" class="reserve-license">
            <div class="head">
              <h5>لایسنس رزرو:</h5>
              <span>پلن استاندارد ۱۰ کاربره</span>
            </div>
            <div class="progress-line mt-2">
              <i :class="{'bg-error2':endLicense}"
                 :style="'width:'+calculatePercentage+'%'"></i>
            </div>

          </div>
        </template>

        <div v-if="product_type !== 'hosted'" class="btns">
          <!--          <button @click="showDetail" class="btn btn-detail">جزییات</button>-->
          <router-link :to="{name:'Licences'}" class="btn mx-1">مدیریت لایسنس ها</router-link>
          <button @click="addUserFunc" :disabled="pendingBill !== null || currentLicense === ''" class="btn">افزایش
            تعداد کاربران
          </button>
        </div>
      </div>


    </div>
    <div class="left-sec">
      <div class="box-main">
        <div class="head pb-4">
          <h6>آخرین لاگین ها</h6>
          <div class="tab">
            <span class="active">24 ساعت</span>
            <!--            <span>7 ساعت</span>-->
          </div>
        </div>

        <ul class="list-users">
          <li v-for="(item,index) in recentLogons" :key="index">
            <h6> {{ item.user_name }}<em :class="item.action_type">{{ item.action_type }}</em></h6>
            <span class="d-inline-block">{{ formatTimeDifferenceJalali(item.login_time) }}</span>
          </li>


        </ul>

      </div>

    </div>
    <div class="row w-100">
      <div class="reports-boxes w-100">
        <template v-for="item in stats" :key="item.id">
          <div class="box" v-if="item.key	 !== 'tasks_by_status'">


            <span>{{ item.title }}</span>

            <h6 v-if="typeof item.value === 'number'">{{ item.value }}</h6>

            <template v-else>
              <div v-for="(x,i) in item.value" :key="i" class="mt-2">
                <span>{{ x.status_title }}</span>
                <h6>{{ x.count }}</h6>
              </div>
            </template>
          </div>
        </template>

      </div>
    </div>
    <v-dialog v-model="addUserDialog" width="450px">
      <div class="box-detail">
        <div class="head">
          <h6>افزایش تعداد کاربران</h6>
          <i @click="addUserDialog = false" class="fa-regular fa-close"></i>

        </div>
        <h5>اطلاعات پرداخت</h5>

        <div class="body">
          <ul>
            <li>
              <h4><i class="fa-thin fa-users"></i>تعداد فعلی کاربران:</h4>
              <span>{{ currentLicense.user_count }}</span>
            </li>
            <li>
              <h4><i class="fa-regular fa-hourglass"></i>زمان باقی مانده از لایسنس کنونی</h4>
              <span>{{ currentLicense.remaining_days }} روز</span>
            </li>
            <li>
              <h4><i class="fa-regular fa-user-plus"></i>افزایش تعداد کاربران به:</h4>
              <div class="input position-relative d-flex align-items-center">
                <div class="arrow-input">
                  <button @click="increase"><i class="fa-regular fa-angle-up"></i></button>
                  <button @click="decrease" :disabled="userCount <= 1"><i class="fa-regular fa-angle-down"></i></button>
                </div>

                <input :disabled="loading" v-model="userCount" type="number"
                       min="1" max="10">
              </div>
            </li>
          </ul>

          <h5 class="price"> قابل پرداخت: {{ totalAdditionalCost.toLocaleString() }} تومان</h5>
          <div class="alert alert-danger" role="alert">
            <i class="fa-regular fa-triangle-exclamation"></i>
            <span>توجه داشته باشید که بعد از ثبت، امکان ثبت کاربر جدید، تمدید یا رزرو لایسنس تا زمان تکمیل فرآیند پرداخت وجود ندارد.</span>
          </div>
          <v-btn :loading="loading" class="btn btn-pay" @click="increaseUserCount">ایجاد صورت حساب</v-btn>

        </div>

      </div>
    </v-dialog>
    <v-dialog
        v-model="detailDialog"
        width="600px"
    >
      <div class="box-detail">
        <div class="head">
          <h6>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
              <rect y="0.5" width="24" height="24" fill="url(#pattern0_382_1399)"/>
              <defs>
                <pattern id="pattern0_382_1399" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlink:href="#image0_382_1399" transform="translate(0 -0.00401606) scale(0.00200803)"/>
                </pattern>
                <image id="image0_382_1399" width="498" height="502"
                       xlink:href="data:image/png;base64,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"/>
              </defs>
            </svg>
            جزییات سرویس مدیریت مخاطبین
          </h6>
          <i @click="detailDialog = false" class="fa-regular fa-close"></i>

        </div>
        <h5>اطلاعات پرداخت</h5>
        <ul>
          <li>
            <h6>تاریخ ثبت:</h6>
            <span class="dete">{{ currentLicense.shamsi_create_date }}</span>
          </li>
          <li>
            <h6>تاریخ سررسید:</h6>
            <span class="dete">{{ currentLicense.shamsi_expire_date }}</span>
          </li>
          <li>
            <h6>مبلغ اولیه پرداخت:</h6>
            <span class="price">{{ currentLicense.price.toLocaleString() }} تومان</span>
          </li>
        </ul>
        <h5>اطلاعات سرویس</h5>
        <ul>
          <li>
            <h6>پلن لایسنس:</h6>
            <span>{{ currentLicense.name }}</span>
          </li>
          <li>
            <h6>دوره پرداخت:</h6>
            <span>{{ currentLicense.month_number }} ماهه</span>
          </li>
          <li>
            <h6>تعداد کاربران:</h6>
            <span>{{ currentLicense.lic_val }}</span>
          </li>
        </ul>

      </div>
    </v-dialog>
  </div>
  <v-snackbar
      :timeout="3000"
      v-model="snackbar"
      :color="colorSnack"
  >
    {{ textSnack }}

    <template v-slot:actions>
      <v-btn

          variant="tonal"
          @click="snackbar = false"
      >
        بستن
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import moment from "moment-jalaali";
import Cookies from "js-cookie";
import store from "@/store";

export default {
  name: 'HomeView',
  data() {
    return {
      apiUrl: window.appConfig.API_URL_BASE,
      currentLicense: '',
      countdown: 0,
      aiTokenBalance: '',
      isExpired: false,
      timer: null,
      pendingBill: null,
      reservedLicense: null,
      detailDialog: false,
      licenseActive: true,
      addUserDialog: false,
      recentLogons: [],
      stats: [],
      endLicense: false,
      timeout: null,
      snackbar: false,
      textSnack: '',
      colorSnack: '',
      totalAdditionalCost: '',
      remainingDays: '',
      loading: false,
      loadingCancel: false,
      userCount: 1,
      usersC: 1,
      spentDays: '',
      product_type: "",
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': 'Bearer ' + Cookies.get('token')
      }
    }
  },
  watch: {
    userCount() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.calcIncreaseUserCount();
      }, 700);
    }
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    }
  },
  methods: {
    formatTimeDifferenceJalali(dateString) {
      const now = moment();
      const givenTime = moment(dateString, 'YYYY-MM-DD HH:mm:ss');
      const diffMinutes = now.diff(givenTime, 'minutes');
      const diffHours = now.diff(givenTime, 'hours');

      if (diffMinutes < 60) {
        return `${diffMinutes} دقیقه قبل`;
      } else if (diffHours < 24) {
        return `${diffHours} ساعت قبل`;
      } else {
        return givenTime.format('jYYYY/jMM/jDD HH:mm:ss');
      }
    },
    getRecentLogins() {
      let url = `${this.apiUrl}api/recent-logins`
      this.loadingCancel = true
      axios.get(url, {headers: this.headers})
          .then(res => {
            this.recentLogons = res.data.data

          })
          .catch(err => {

            console.log(err)
          })
    },
    getStats() {
      let url = this.apiUrl + 'api/panel/stats'
      axios.get(url, {headers: this.headers})
          .then(res => {
            this.stats = res.data.data

          })
          .catch(err => {
            this.loadingPage = false
            console.log(err)
          })
    },
    billsCancel() {
      let id = this.pendingBill.id
      let url = `${this.apiUrl}api/license/bills/${id}/cancel`
      this.loadingCancel = true
      axios.post(url, '', {headers: this.headers})
          .then(() => {
            this.userCount = 1
            this.getLicensePurchased()
            this.loadingCancel = false
            localStorage.removeItem("payCountdown");
          })
          .catch(err => {
            this.loadingCancel = false
            console.log(err)
          })

    },
    getUsers() {
      let url = this.apiUrl + 'api/users?per_page=' + 1
      axios.get(url, {headers: this.headers})
          .then(res => {
            this.loadingPage = false
            this.usersC = res.data?.data?.total

          })
          .catch(err => {
            this.loadingPage = false
            console.log(err)
          })
    },
    getUserInfo() {
      let data = JSON.parse(localStorage.getItem('userInfo'))
      this.product_type = data?.data?.product_type


    },
    calculatePercentage(part, total) {

      if (total === 0) return 0;
      return (part / total) * 100;
    },
    getPayUrl() {
      window.location.href = `https://api.agistant.com/bills/${this.pendingBill.uuid}/payment?redirect_url=https://panel.agistant.com/`
    },
    calcIncreaseUserCount() {
      let data = {
        license_id: this.currentLicense.id,
        new_user_count: this.userCount,
      }
      this.loading = true
      axios.post(this.apiUrl + 'api/license/calc-increase-user-count', data, {headers: this.headers})
          .then(res => {
            this.totalAdditionalCost = res.data.total_additional_cost
            this.loading = false
            this.additionalUsers = res.data.additional_users

          })
          .catch(err => {
            this.loadingSkeleton = false
            this.loading = false
            if (err?.response?.status === 401) {
              this.logout()
            }
            console.log(err)
            if (err?.response?.status === 400) {
              this.showMsg(err?.response?.data?.error, 'red')
              this.addUserDialog = false
            }
          })
    },
    increaseUserCount() {
      let data = {
        license_id: this.currentLicense.id,
        additional_users: this.additionalUsers,
      }
      this.loading = true
      axios.post(this.apiUrl + 'api/license/increase-user-count', data, {headers: this.headers})
          .then(() => {
            this.loading = false
            this.addUserDialog = false
            this.getLicensePurchased()
            /*  let bil_id = res.data.bill.id
            window.location.href = `https://api.agistant.com/bills/${bil_id}/payment?redirect_url=https://panel.agistant.com/`
 */
          })
          .catch(err => {
            this.loadingSkeleton = false
            this.loading = false
            if (err?.response?.status === 401) {
              this.logout()
            }
          })
    },
    addUserFunc() {
      this.addUserDialog = true
      this.calcIncreaseUserCount()

    },
    getAiTokenBalance() {
      let url = this.apiUrl + 'api/license/get-ai-token-balance'

      axios.get(url, {headers: this.headers})
          .then(res => {
            this.aiTokenBalance = res.data.ai_token_balance

          })
          .catch(err => {
            if (err?.response?.status === 401) {
              this.logout()
            }

          })
    },
    getLicensePurchased() {
      let url = this.apiUrl + 'api/license/get-user-license-info'

      axios.get(url, {headers: this.headers})
          .then(res => {
            this.currentLicense = res?.data?.current_license
            this.pendingBill = res.data.pending_bill
            this.getAiTokenBalance()
            if (this.pendingBill !== null) {
              this.startCountdown();
            } else {
              localStorage.removeItem("payCountdown");
            }
            this.getUsers()
            this.checkEndLicense()
            if (this.currentLicense.status === 'expired') {
              this.licenseActive = false
            }
          })
          .catch(err => {
            if (err?.response?.status === 401) {
              this.logout()
            }

          })
    },
    startCountdown() {
      const storedTime = localStorage.getItem("payCountdown");
      const now = Math.floor(Date.now() / 1000);

      if (storedTime && storedTime > now) {
        this.countdown = storedTime - now;
      } else {
        this.countdown = 20 * 60; // 20 دقیقه
        localStorage.setItem("payCountdown", now + this.countdown);
      }

      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.isExpired = true;
          clearInterval(this.timer);
          this.handleTimeout();
        }
      }, 1000);
    },
    handleTimeout() {
      this.billsCancel()
      localStorage.removeItem("payCountdown");

    },
    increase() {
      this.userCount++;

    },
    decrease() {
      this.userCount--;

    },
    removeCookie() {
      Cookies.remove('token');
    },
    logout() {
      store.commit('setLogout', true);
    },
    showMsg(msg, color) {
      this.snackbar = true
      this.textSnack = msg
      this.colorSnack = color
    },
    checkEndLicense() {
      this.spentDays = this.currentLicense.all_day - this.currentLicense.count_day_to_expire
      if ((this.currentLicense.all_day - this.spentDays) <= 2) {
        this.endLicense = true
      }


    },

    showDetail() {
      this.detailDialog = true

    },

    getCookie() {
      return Cookies.get('token');
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  mounted() {
    this.getUserInfo()
    if (this.product_type !== 'hosted') {

      this.getLicensePurchased()
    }


    this.getRecentLogins()
    this.getStats()
  }


}
</script>
<style scoped lang="scss">
.reports-boxes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  .box {
    width: calc(25% - 10px);
    border-radius: 24px;
    border: 1px solid #D7DBE0;
    display: flex;
    flex-direction: column;
    padding: 24px;
    margin: 10px 0;

    i {
      font-size: 20px;
      color: #FFCA70;
      margin-bottom: 18px;
    }

    span {
      color: #6C798B;
      font-size: 14px;
    }

    h6 {
      font-size: 32px;
      color: #24272D;
      margin-bottom: 0;
      margin-top: 5px;
    }

  }
}

.bg-error2 {
  background: #E22C1F !important;
}

.alert-danger {
  border-radius: 99px;

  i {
    color: #E22C1F;
    margin-left: 5px;
  }
}

.arrow-input {
  display: flex;
  flex-wrap: wrap;
  width: 15px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 13px;
  height: 34px;

  button {
    color: #24272D;
    cursor: pointer;
    display: flex;

    &:disabled {
      cursor: default;

      i {
        color: #B3BBC6;
      }
    }
  }
}

.btn-pay {
  padding: 8px 16px;
  border-radius: 99px;
  border: 1px solid #82211A;
  color: #82211A;
  font-size: 12px;

  span {
    min-width: 40px;
    display: inline-block;
  }
}

.error {
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 10px;

  span {
    color: #E22C1F !important;
    margin-left: 10px;
    margin-bottom: 0 !important;
    width: auto !important;
  }

  a.btn {
    font-size: 10px;
    color: #E22C1F;
    border: 1px solid #FFE3E1;
    padding: 4px 12px;
    border-radius: 99px;
    width: max-content;

  }
}

.box-detail {
  background: #fff;
  border-radius: 32px;
  padding: 32px;
  max-height: 100vh;
  overflow: auto;
  scrollbar-width: thin;

  h5 {
    margin: 15px 0;
    font-size: 16px;
  }

  .head {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    i {
      margin-right: auto;
      cursor: pointer;
    }
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 10px 0;

      .dete {
        direction: ltr;
      }

      h6 {
        margin-bottom: 0;
        margin-left: auto;
        font-weight: 100;
        font-size: 14px;
        color: #24272D;
      }

      span {
        font-size: 14px;
        color: #474F5D;
      }
    }
  }

  .body {
    ul {

      li {
        display: flex;
        align-items: center;

        h4 {
          font-size: 14px;
          color: #24272D;
          margin-left: auto;
          font-weight: 500;

          i {
            margin-left: 5px;
            color: #B3BBC6;
          }
        }

        .input {
          input {
            width: 122px;
            height: 45px;
            border: 1px solid #B3BBC6;
            border-radius: 99px;
            padding: 10px;

          }
        }
      }
    }

    .price {
      width: 100%;
      padding-top: 10px;
      font-size: 20px;
      color: #363B44;
      font-weight: bold;
      text-align: center;
    }

    .alert-danger {
      display: flex;
      border: none;
      border-radius: 16px;

      span {
        color: #82211A;
        font-weight: 600;
      }
    }

    .btn-pay {
      width: 100%;
      background: #22AA24;
      border-radius: 99px;
      border: 1px solid #22AA24;
      color: #D8F4FF;
    }
  }
}

.factor-pay {
  width: 100%;
  padding: 12px 16px;
  border-radius: 16px;
  background: #FFE3E1;

  .head {
    h5 {
      font-size: 14px;
      color: #82211A;

      i {
        margin-left: 5px;
        color: #E22C1F;
      }
    }

    button {
      margin-right: auto;
      background: #E22C1F;
      color: #fff;
      border-radius: 8px;
      padding: 8px;
      font-size: 12px;
    }
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      color: #24272D;
      padding: 10px 0;

      h6 {
        margin-left: auto;

        i {
          margin-left: 5px;
        }
      }
    }
  }

  .btns-2 {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-top: 10px;

    button {
      font-size: 12px;
      border-radius: 99px;
      margin-right: 10px;
    }

    .btn-cancel {
      border: 1px solid #E22C1F;
      color: #E22C1F;
      background: transparent;
      box-shadow: none;
    }

    .btn-pay {
      background: #22AA24;
      border: 1px solid #22AA24;
      color: #FFFFFF;
    }
  }

}

.reserve-license {
  width: 100%;
  border-top: 1px solid #D7DBE0;
  padding-top: 15px;
  margin-top: 15px;

  .head {
    display: flex;
    align-items: center;

    h5 {
      font-size: 14px;
      margin-left: auto;
    }

    span {
      padding: 4px 8px;
      display: inline-block;
      background: #EDEEF1;
      border-radius: 8px;
      color: #474F5D;
    }
  }

}

.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .btn {
    width: calc(50% - 10px);
    background: #24272D;
    border-radius: 99px;
    color: #fff;
    padding: 8px;
    font-size: 14px;
    margin-top: 15px;
    transition: all ease .4s;
    border: 1px solid #24272D;

    &:disabled {
      background: #D7DBE0;
      border: 1px solid #D7DBE0;
    }

    &:hover {
      opacity: .7;
    }

    &.btn-detail {
      background: #fff;
      color: #24272D;
      border: 1px solid #24272D;


    }

  }

}

.center-sec {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  .box-main {
    width: 100%;
    margin: 10px;
    border: 1px solid #F3F4F6;
    border-radius: 32px;
    padding: 24px 15px;


    .head {
      display: flex;
      align-items: center;

      .icon-1 {
        width: 52px;
        height: 52px;
        background: url("../assets/images/icons/icon1.png");
      }

      .icon-2 {
        width: 52px;
        height: 52px;
        background: url("../assets/images/icons/icon2.png");
      }

      .icon-3 {
        width: 52px;
        height: 52px;
        background: url("../assets/images/icons/icon3.png");
      }

      .icon-4 {
        width: 52px;
        height: 52px;
        background: url("../assets/images/icons/icon4.png");
      }

      .txt {
        padding-right: 10px;
        width: calc(100% - 52px);

        h6 {
          font-size: 20px;
          font-weight: 600;
        }
      }
    }

    .progress-line {
      width: 100%;
      height: 10px;
      background: #EDEEF1;
      border-radius: 99px;
      position: relative;
      overflow: hidden;

      i {
        content: '';
        width: 50%;
        height: 100%;
        right: 0;
        top: 0;
        background: #22AA24;
        border-radius: 99px;
        position: absolute;
      }

    }

    .box-mini {
      width: 100%;
      border-radius: 8px;
      font-size: 12px;
      padding: 4px 8px;
      margin-left: 5px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 15px;

      span {
        font-size: 11px;
        color: #8B8B8B;
        width: 100%;
        margin-bottom: 5px;
        display: block;
      }


    }


  }
}

.left-sec {
  width: 50%;

  .box-main {
    width: 100%;
    margin: 10px;
    border: 1px solid #F3F4F6;
    border-radius: 32px;
    padding: 24px 0;

    .head {
      display: flex;
      align-items: center;
      padding: 0 15px;

      h6 {
        font-size: 16px;

      }

      .tab {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-right: auto;
        background: #F3F4F6;
        border-radius: 99px;
        padding: 5px;

        span {
          padding: 5px 10px;
          color: #566173;
          cursor: pointer;
        }

        .active {
          background: #24272D;
          border-radius: 99px;
          color: #fff;
          cursor: default;

        }
      }
    }

    .list-users {
      padding: 0 15px;
      margin: 0;
      max-height: 400px;
      overflow: auto;
      scrollbar-width: thin;

      li {
        display: flex;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #F3F4F6;

        &:last-child {
          border-bottom: none;
        }


        h6 {
          font-size: 14px;

          em {
            font-weight: 100;
            padding: 4px 8px;
            font-size: 8px;
            border-radius: 99px;
            background: #22AA24;
            color: #DEFADE;
            margin-right: 5px;
            display: inline-block;

            &.offline {
              background: #FFE3E1;
              color: #E22C1F;
            }

          }
        }

        span {
          font-size: 10px;
          color: #566173;
          margin-right: auto;
          direction: ltr;
        }

      }
    }
  }
}

@media (max-width: 767px) {
  .center-sec {
    width: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;

    .box-main {
      min-width: 300px;

      .box-mini {
        max-width: none;
      }
    }
  }
  .left-sec {
    width: 100%;
  }

}
</style>
